import * as types from "./types";

export function goToGroup(groupID) {
  return dispatch => {
    dispatch({
      type: types.GO_TO_GROUP,
			currentGroup: groupID,
			backToParent: false
    });
  };
}

export function goBack() {
  return dispatch => {
    dispatch({
			type: types.GO_BACK,
			backToParent: true
		});
  };
}

export function goToStage(stageID) {
  return dispatch => {
    dispatch({
      type: types.GO_TO_STAGE,
      currentStage: stageID
    });
  };
}

export function setCurrentVideoLoaded() {
  return dispatch => {
    dispatch({
      type: types.SET_CURRENT_VIDEO_LOADED,
      nextVideoLoaded: true
    });
  };
}

export function setVideoLoaded(videoName) {
  return dispatch => {
    dispatch({
      type: types.SET_VIDEO_LOADED,
      name: videoName
    });
  };
}

export function setNextVideoLoaded() {
  return dispatch => {
    dispatch({
      type: types.SET_NEXT_VIDEO_LOADED,
      nextVideoLoaded: true
    });
  };
}

export function toggleMoreInfoSidePanel(bool, data) {
  return dispatch => {
    dispatch({
      type: types.TOGGLE_MORE_INFO_SIDE_PANEL,
      showMoreInfoSidePanel: bool,
      moreInfoData: data
    });
  };
}

export function unityChangeCamera(cameraString) {
  return dispatch => {
    dispatch({
      type: types.CHANGE_UNITY_CAMERA,
      unityCamera: cameraString
    });
  };
}

export function setLoader(bool) {
  return dispatch => {
    dispatch({
      type: types.SET_LOADER,
      loader: bool
    });
  };
}

export function setLoaderProgress(percentage) {
  return dispatch => {
    dispatch({
      type: types.SET_LOADER_PROGRESS,
      loaderProgress: percentage
    });
  };
}
export function setUnityAnimation(animationName) {
  return dispatch => {
    dispatch({
      type: types.UNITY_SET_ANIMATION,
      unityAnimation: animationName
    });
  };
}

export function unsetNavigationWait() {
  return dispatch => {
    dispatch({
      type: types.UNSET_NAVIGATION_WAIT
    });
  };
}
export function setNavigationWait() {
  return dispatch => {
    dispatch({
      type: types.SET_NAVIGATION_WAIT
    });
  };
}
